/** DO NOT EDIT: THIS FILE WAS AUTOMATICALLY GENERATED BY A TOOL **/
/* jshint ignore:start */
/* eslint-disable */
import axios from 'axios';
import options from 'config';
import {
    restAPIV4
} from '@/resources/rest_api_v4.js';

const DOMAIN = options.console_api_url || 'https://console.viafoura.co/v4/console';

/**
 * HTTP Request
 * @method
 * @name consoleAPI#request
 * @param {string} method - http method
 * @param {string} url - url to do request
 * @param {object} parameters
 * @param {object} data - body parameters / object
 * @param {object} headers - header parameters
 * @param {object} config - extra configuration
 * @returns {Promise} promise
 */
function request(method, url, params, data, headers, config = {}) {
    return restAPIV4.register(DOMAIN).api.request({
        withCredentials: true,
        headers,
        method,
        params,
        data,
        url,
        ...config,
    });
};

/**
 * Stores the occurrence of an event on the user's dashboard
 * @method
 * @name consoleAPI#reportEvent
 * @param {object} parameters - method options and parameters
 * @param {} parameters.event - Event post
 * @param {object} config - extra configuration
 */
export function reportEvent(parameters = {}, config = {}) {
    let path = '/analytics';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['event'] !== undefined) {
        data = parameters['event'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Stores the occurrence of a User time event
 * @method
 * @name consoleAPI#reportUserTimeEvent
 * @param {object} parameters - method options and parameters
 * @param {} parameters.event - User Time Event post
 * @param {object} config - extra configuration
 */
export function reportUserTimeEvent(parameters = {}, config = {}) {
    let path = '/analytics/users/time';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['event'] !== undefined) {
        data = parameters['event'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Creates a new piece of content to moderate
 * @method
 * @name consoleAPI#createContent
 * @param {object} parameters - method options and parameters
 * @param {} parameters.content - Content post
 * @param {object} config - extra configuration
 */
export function createContent(parameters = {}, config = {}) {
    let path = '/content';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['content'] !== undefined) {
        data = parameters['content'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Logs an action performed on a piece of content
 * @method
 * @name consoleAPI#createContentAction
 * @param {object} parameters - method options and parameters
 * @param {} parameters.contentAction -
 * @param {object} config - extra configuration
 */
export function createContentAction(parameters = {}, config = {}) {
    let path = '/content/action';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['content_action'] !== undefined) {
        data = parameters['content_action'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Gets all the actions that have occurred on a content
 * @method
 * @name consoleAPI#getContentActions
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.contentUuid -
 * @param {string} parameters.service -
 * @param {object} config - extra configuration
 */
export function getContentActions(parameters = {}, config = {}) {
    let path = '/content/action';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['content_uuid'] !== undefined) {
        params['content_uuid'] = parameters['content_uuid'];
    }

    if (parameters['service'] !== undefined) {
        params['service'] = parameters['service'];
    }

    return request('GET', path, params, data, headers, config);
};

/**
 * Logs an assessment on a piece of content
 * @method
 * @name consoleAPI#createContentAssessment
 * @param {object} parameters - method options and parameters
 * @param {} parameters.contentAssessment - Content post
 * @param {object} config - extra configuration
 */
export function createContentAssessment(parameters = {}, config = {}) {
    let path = '/content/assessment';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['content_assessment'] !== undefined) {
        data = parameters['content_assessment'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Gets all the tags attached to a piece of content
 * @method
 * @name consoleAPI#getContentTags
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.contentId -
 * @param {string} parameters.contentUuid -
 * @param {string} parameters.service -
 * @param {object} config - extra configuration
 */
export function getContentTags(parameters = {}, config = {}) {
    let path = '/content/tag';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['content_id'] !== undefined) {
        params['content_id'] = parameters['content_id'];
    }

    if (parameters['content_uuid'] !== undefined) {
        params['content_uuid'] = parameters['content_uuid'];
    }

    if (parameters['service'] !== undefined) {
        params['service'] = parameters['service'];
    }

    return request('GET', path, params, data, headers, config);
};

/**
 * Adds a tag onto a piece of content
 * @method
 * @name consoleAPI#addContentTag
 * @param {object} parameters - method options and parameters
 * @param {} parameters.contentTag - Content tag
 * @param {object} config - extra configuration
 */
export function addContentTag(parameters = {}, config = {}) {
    let path = '/content/tag';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['content_tag'] !== undefined) {
        data = parameters['content_tag'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Gets the agreement rate for community proposed tags for the provided users.
 * @method
 * @name consoleAPI#getTagAgreementRate
 * @param {object} parameters - method options and parameters
 * @param {} parameters.actors -
 * @param {object} config - extra configuration
 */
export function getTagAgreementRate(parameters = {}, config = {}) {
    let path = '/content/tag/community_agreement';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['actors'] !== undefined) {
        data = parameters['actors'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Refreshes a piece of content (as a fallback if things go out of sync for users to call)
 * @method
 * @name consoleAPI#refreshContent
 * @param {object} parameters - method options and parameters
 * @param {} parameters.content - Content post
 * @param {object} config - extra configuration
 */
export function refreshContent(parameters = {}, config = {}) {
    let path = '/content/refresh';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['content'] !== undefined) {
        data = parameters['content'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Retrieves the parent of the content
 * @method
 * @name consoleAPI#getParentOfContent
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.contentUuid -
 * @param {string} parameters.parentContentUuid -
 * @param {string} parameters.service -
 * @param {object} config - extra configuration
 */
export function getParentOfContent(parameters = {}, config = {}) {
    let path = '/content/{content_uuid}/parent/{parent_content_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{content_uuid}', parameters['content_uuid']);

    path = path.replace('{parent_content_uuid}', parameters['parent_content_uuid']);

    if (parameters['service'] !== undefined) {
        params['service'] = parameters['service'];
    }

    return request('GET', path, params, data, headers, config);
};

/**
 * Creates a new workspace for a moderator
 * @method
 * @name consoleAPI#createWorkspace
 * @param {object} parameters - method options and parameters
 * @param {} parameters.workspace - Workspace post
 * @param {object} config - extra configuration
 */
export function createWorkspace(parameters = {}, config = {}) {
    let path = '/workspace';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['workspace'] !== undefined) {
        data = parameters['workspace'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Returns all workspaces a user has access to
 * @method
 * @name consoleAPI#getWorkspaces
 * @param {object} parameters - method options and parameters
 * @param {object} config - extra configuration
 */
export function getWorkspaces(parameters = {}, config = {}) {
    let path = '/workspace';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    return request('GET', path, params, data, headers, config);
};

/**
 * Returns a workspace, and if the user doesn't own it, adds it to the list of workspaces for the user
 * @method
 * @name consoleAPI#getWorkspace
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.workspaceUuid - The workspace uuid to get
 * @param {object} config - extra configuration
 */
export function getWorkspace(parameters = {}, config = {}) {
    let path = '/workspace/{workspace_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{workspace_uuid}', parameters['workspace_uuid']);

    return request('GET', path, params, data, headers, config);
};

/**
 * Delete workspace
 * @method
 * @name consoleAPI#deleteWorkspace
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.workspaceUuid - The workspace uuid to delete
 * @param {object} config - extra configuration
 */
export function deleteWorkspace(parameters = {}, config = {}) {
    let path = '/workspace/{workspace_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{workspace_uuid}', parameters['workspace_uuid']);

    return request('DELETE', path, params, data, headers, config);
};

/**
 * Rename workspace
 * @method
 * @name consoleAPI#renameWorkspace
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.workspaceUuid - The workspace uuid to rename
 * @param {} parameters.mutation - A RFC 6902 compliant document. Only add, replace and remove operations are supported.
 * @param {object} config - extra configuration
 */
export function renameWorkspace(parameters = {}, config = {}) {
    let path = '/workspace/{workspace_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{workspace_uuid}', parameters['workspace_uuid']);

    if (parameters['mutation'] !== undefined) {
        data = parameters['mutation'];
    }

    return request('PATCH', path, params, data, headers, config);
};

/**
 * Copies the specified workspace, returning the newly created copy.
 * @method
 * @name consoleAPI#copyWorkspace
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.workspaceUuid - The workspace uuid to copy
 * @param {object} config - extra configuration
 */
export function copyWorkspace(parameters = {}, config = {}) {
    let path = '/workspace/{workspace_uuid}/copy';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{workspace_uuid}', parameters['workspace_uuid']);

    return request('POST', path, params, data, headers, config);
};

/**
 * Returns all clients with sites that a user has access to
 * @method
 * @name consoleAPI#getClients
 * @param {object} parameters - method options and parameters
 * @param {object} config - extra configuration
 */
export function getClients(parameters = {}, config = {}) {
    let path = '/clients';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    return request('GET', path, params, data, headers, config);
};

/**
 * Creates a new search
 * @method
 * @name consoleAPI#createSearch
 * @param {object} parameters - method options and parameters
 * @param {} parameters.search - Search
 * @param {object} config - extra configuration
 */
export function createSearch(parameters = {}, config = {}) {
    let path = '/saved_search';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['search'] !== undefined) {
        data = parameters['search'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Get saved_search
 * @method
 * @name consoleAPI#getSavedSearch
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.savedSearchUuid - The saved_search uuid to get
 * @param {array} parameters.searchAfter - The sort values returned by the previous page to pass to the next
 * @param {integer} parameters.pageSize -
 * @param {} parameters.sortOrder -
 * @param {} parameters.sortField -
 * @param {object} config - extra configuration
 */
export function getSavedSearch(parameters = {}, config = {}) {
    let path = '/saved_search/{saved_search_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{saved_search_uuid}', parameters['saved_search_uuid']);

    if (parameters['search_after'] !== undefined) {
        params['search_after'] = parameters['search_after'];
    }

    if (parameters['page_size'] !== undefined) {
        params['page_size'] = parameters['page_size'];
    }

    if (parameters['sort_order'] !== undefined) {
        params['sort_order'] = parameters['sort_order'];
    }

    if (parameters['sort_field'] !== undefined) {
        params['sort_field'] = parameters['sort_field'];
    }

    return request('GET', path, params, data, headers, config);
};

/**
 * Delete saved_search
 * @method
 * @name consoleAPI#deleteSavedSearch
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.savedSearchUuid - The saved_search uuid to delete
 * @param {object} config - extra configuration
 */
export function deleteSavedSearch(parameters = {}, config = {}) {
    let path = '/saved_search/{saved_search_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{saved_search_uuid}', parameters['saved_search_uuid']);

    return request('DELETE', path, params, data, headers, config);
};

/**
 * Updates an existing saved search search
 * @method
 * @name consoleAPI#updateSearch
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.savedSearchUuid - The saved_search uuid to update
 * @param {} parameters.search - Search
 * @param {object} config - extra configuration
 */
export function updateSearch(parameters = {}, config = {}) {
    let path = '/saved_search/{saved_search_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{saved_search_uuid}', parameters['saved_search_uuid']);

    if (parameters['search'] !== undefined) {
        data = parameters['search'];
    }

    return request('PUT', path, params, data, headers, config);
};

/**
 * Exports a Saved Search
 * @method
 * @name consoleAPI#exportSavedSearch
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.savedSearchUuid - The saved_search uuid to get
 * @param {array} parameters.searchAfter - The sort values returned by the previous page to pass to the next
 * @param {integer} parameters.pageSize -
 * @param {} parameters.sortOrder -
 * @param {} parameters.sortField -
 * @param {object} config - extra configuration
 */
export function exportSavedSearch(parameters = {}, config = {}) {
    let path = '/saved_search/{saved_search_uuid}/export';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{saved_search_uuid}', parameters['saved_search_uuid']);

    if (parameters['search_after'] !== undefined) {
        params['search_after'] = parameters['search_after'];
    }

    if (parameters['page_size'] !== undefined) {
        params['page_size'] = parameters['page_size'];
    }

    if (parameters['sort_order'] !== undefined) {
        params['sort_order'] = parameters['sort_order'];
    }

    if (parameters['sort_field'] !== undefined) {
        params['sort_field'] = parameters['sort_field'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Creates a new queue
 * @method
 * @name consoleAPI#createQueue
 * @param {object} parameters - method options and parameters
 * @param {} parameters.queue - Queue
 * @param {object} config - extra configuration
 */
export function createQueue(parameters = {}, config = {}) {
    let path = '/queue';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['queue'] !== undefined) {
        data = parameters['queue'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Delete queue
 * @method
 * @name consoleAPI#deleteQueue
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.queueUuid - The queue uuid to delete
 * @param {object} config - extra configuration
 */
export function deleteQueue(parameters = {}, config = {}) {
    let path = '/queue/{queue_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{queue_uuid}', parameters['queue_uuid']);

    return request('DELETE', path, params, data, headers, config);
};

/**
 * Updates an existing queue
 * @method
 * @name consoleAPI#updateQueue
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.queueUuid - The queue uuid to update
 * @param {} parameters.queue - Queue
 * @param {object} config - extra configuration
 */
export function updateQueue(parameters = {}, config = {}) {
    let path = '/queue/{queue_uuid}';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{queue_uuid}', parameters['queue_uuid']);

    if (parameters['queue'] !== undefined) {
        data = parameters['queue'];
    }

    return request('PUT', path, params, data, headers, config);
};

/**
 * Get the results from the given search.
 * @method
 * @name consoleAPI#getQuickSearchResults
 * @param {object} parameters - method options and parameters
 * @param {} parameters.searchDefinition -
 * @param {array} parameters.searchAfter - The sort values returned by the previous page to pass to the next
 * @param {integer} parameters.pageSize -
 * @param {} parameters.sortOrder -
 * @param {} parameters.sortField -
 * @param {object} config - extra configuration
 */
export function getQuickSearchResults(parameters = {}, config = {}) {
    let path = '/quick_search';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['searchDefinition'] !== undefined) {
        data = parameters['searchDefinition'];
    }

    if (parameters['search_after'] !== undefined) {
        params['search_after'] = parameters['search_after'];
    }

    if (parameters['page_size'] !== undefined) {
        params['page_size'] = parameters['page_size'];
    }

    if (parameters['sort_order'] !== undefined) {
        params['sort_order'] = parameters['sort_order'];
    }

    if (parameters['sort_field'] !== undefined) {
        params['sort_field'] = parameters['sort_field'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Get the results from the given quick search.
 * @method
 * @name consoleAPI#exportQuickSearchResults
 * @param {object} parameters - method options and parameters
 * @param {} parameters.searchDefinition -
 * @param {array} parameters.searchAfter - The sort values returned by the previous page to pass to the next
 * @param {integer} parameters.pageSize -
 * @param {} parameters.sortOrder -
 * @param {} parameters.sortField -
 * @param {object} config - extra configuration
 */
export function exportQuickSearchResults(parameters = {}, config = {}) {
    let path = '/quick_search/export';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['searchDefinition'] !== undefined) {
        data = parameters['searchDefinition'];
    }

    if (parameters['search_after'] !== undefined) {
        params['search_after'] = parameters['search_after'];
    }

    if (parameters['page_size'] !== undefined) {
        params['page_size'] = parameters['page_size'];
    }

    if (parameters['sort_order'] !== undefined) {
        params['sort_order'] = parameters['sort_order'];
    }

    if (parameters['sort_field'] !== undefined) {
        params['sort_field'] = parameters['sort_field'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Gets the ratio of disabled comments for each user passed in
 * @method
 * @name consoleAPI#getDisabledContentRatio
 * @param {object} parameters - method options and parameters
 * @param {} parameters.actors -
 * @param {object} config - extra configuration
 */
export function getDisabledContentRatio(parameters = {}, config = {}) {
    let path = '/disabled_content_ratio';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['actors'] !== undefined) {
        data = parameters['actors'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 * Creates a batch for the specified queue.
 * @method
 * @name consoleAPI#createBatch
 * @param {object} parameters - method options and parameters
 * @param {} parameters.createBatchRequest - The request to make the batch
 * @param {object} config - extra configuration
 */
export function createBatch(parameters = {}, config = {}) {
    let path = '/batch';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    if (parameters['createBatchRequest'] !== undefined) {
        data = parameters['createBatchRequest'];
    }

    return request('POST', path, params, data, headers, config);
};

/**
 *
 * @method
 * @name consoleAPI#deleteBatch
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.batchUuid -
 * @param {object} config - extra configuration
 */
export function deleteBatch(parameters = {}, config = {}) {
    let path = '/batch/{batch_uuid}/delete';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{batch_uuid}', parameters['batch_uuid']);

    return request('POST', path, params, data, headers, config);
};

/**
 *
 * @method
 * @name consoleAPI#batchIsActive
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.batchUuid -
 * @param {object} config - extra configuration
 */
export function batchIsActive(parameters = {}, config = {}) {
    let path = '/batch/{batch_uuid}/is_active';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{batch_uuid}', parameters['batch_uuid']);

    return request('POST', path, params, data, headers, config);
};

/* jshint ignore:end */